module.exports = __webpack_public_path__ + "static/media/AmericanExpress.8d5b1866.svg";